import { defaultAbnsCertificationData } from '../../../../backend/config/classifiers/defaults/DefaultAbnsCertificationData';
import { abnsCertificationSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const abnsCertificationEntityName = 'abnsCertification';
const abnsCertificationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineAbnsCertificationClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 4,
            columns: abnsCertificationColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { search: [params.data.name, params.data.status].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultAbnsCertificationData,
        publicData: true,
    }, abnsCertificationSchema);
}
